import valueProc from "./valueProc";

const isRuleGroup = (ruleOrGroup) => {
    return ruleOrGroup.hasOwnProperty('filters');
};

const unparseQuery = (ruleGroup) => {

    const processRule = (rule, id) => {
        let operator = rule.operator || "=";
        const value = valueProc(rule.field, operator, rule.value);

        switch(operator.toLowerCase()) {
            case 'is null':
                operator = 'null';
                break;
            case 'not isnull':
                operator = 'notnull';
                break;
            case 'not in':
                operator = 'notin';
                break;
            case 'like':
                operator = 'contains';
                break;
            case 'not like':
                operator = 'doesnotcontain';
                break;
            default:
                break;
        }

        return {field: rule.field, operator, value, id: "r-" + id};
    };

    const processRuleGroup = (rg, id) => {
        const processedRules = rg.filters.map((rule, idx) => {
            if (isRuleGroup(rule)) {
                return processRuleGroup(rule, id + "-" + idx);
            }
            return processRule(rule, id + "-" + idx);
        });
        return {rules: processedRules, combinator: (rg.operator || "and").toLowerCase(), id: "g-" + id};
    };

    return processRuleGroup(ruleGroup);
}

export default unparseQuery;